<template>
    <div>
        <!-- <section class="inner_banner">

        </section> -->

        <section class="affiliate">
            <div class="container">
                <article class="row justify-content-center">
                    <aside class="col-md-6">
                        <h2>Affiliate</h2>
                        <div class="affiliate_inner">
                            <div class="form-group">
                                <label for="etherium-address">Enter Ethereum Address</label>
                                <input id="etherium-address" type="text" class="form-control" v-model="address">
                            </div>
                            <div class="button_wrapp">
                                <a href="#" @click="onGenerate" class="btn_blue">Generate a Referral Code </a>
                            </div>
                        </div>
                    </aside>
                </article>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: 'Affiliate',
    data () {
        return {
            address: ''
        }
    },
    methods: {
        onGenerate (e) {
            e.preventDefault()
            // console.log(this.address)
        }
    }
}
</script>

<style scoped>

</style>
